import select from './SearchHospitalSelect.vue'
const SearchHospitalSelect = {
  install: function (Vue) {
    Vue.component('SearchHospitalSelect', select)
  }
}
export default SearchHospitalSelect
